import EducationMasterForm from "./EducationMasterForm";

const EditEducation = () => (
  <EducationMasterForm
    title="Education"
    backPath="/all-education"
    submitLabel="Update Education"
    addEndpoint="/admin/add-education"
    getEndpoint="/admin/get-education"
    updateEndpoint="/admin/update-education"
    responseKey="Education"
    includeCategory
  />
);

export default EditEducation;
